import Lookup from 'src/componentes/select2';
import TabelaEdit from 'src/paginas/tabela-valor/edit';

const TabelaValor = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TabelaValorLookup"
    editComponent={TabelaEdit}
    {...rest}
  />
);

export default TabelaValor;
